export const module = {
  info: {
    name: 'voip-rate-division-sms-side-menu',
    caption: 'voip rate division sms side menu',
    viewGroup: 'fasfreeroute-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'SMS Rate Division',
    icon: 'el-icon-copy-document',
    routeName: 'module->voip-rate-division-sms->list->page',
    routeParams: { listPage: 1}
  }
}

export default module
